module.exports = __webpack_public_path__ + "media/images/pages/img_cover_left_03-c4755722bc47db4c747e4fcd1020892c.jpg";